import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgSunburst = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 15"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m6.03 5.102-.36.061c-1.692.313-3.344.941-4.74 1.908 1.397.967 3.048 1.595 4.74 1.908q.18.034.361.061.029.181.061.362c.313 1.691.941 3.343 1.908 4.74.967-1.398 1.595-3.049 1.908-4.74q.034-.18.061-.361.182-.03.362-.062a13.4 13.4 0 0 0 2.137-.578l1.014-.421c.554-.26 1.086-.561 1.585-.906l.004-.003c-1.398-.967-3.05-1.595-4.741-1.908q-.18-.033-.36-.061-.03-.18-.062-.361a13.4 13.4 0 0 0-.579-2.138L8.91 1.59c-.26-.554-.562-1.086-.907-1.585L8 .001C7.033 1.398 6.405 3.05 6.092 4.74q-.034.18-.061.361"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgSunburst;
